import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from "history";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
const customHistory = createBrowserHistory();

const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
if (path) {
  window.location.hash = '';
  window.history.replaceState({}, '', `/tourism-community-stories${path}`);
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter history={customHistory}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
